import { render, staticRenderFns } from "./OffshorePrintingCutting.vue?vue&type=template&id=6c6d6d5d&scoped=true"
import script from "./OffshorePrintingCutting.vue?vue&type=script&setup=true&lang=js"
export * from "./OffshorePrintingCutting.vue?vue&type=script&setup=true&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=6c6d6d5d&prod&scoped=true&lang=css&external"
import style1 from "@/assets/css/custom.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6d6d5d",
  null
  
)

export default component.exports